import gql from 'graphql-tag';

const HARD_RESET_CLIENT_CONTRACTS = gql`
  mutation hardResetClientContracts($input: ClientIdentifierInput!) {
    hardResetClientContracts(input: $input)
  }
`;

const DELETE_CLIENT_CONTRACT_NEW = gql`
  mutation deleteClientContract($input: ContractIdentifierInput!) {
    deleteClientContract(input: $input)
  }
`;

const EXPIRE_CLIENT_CONTRACT_NEW = gql`
  mutation expireClientContract($input: ContractIdentifierInput!) {
    expireClientContract(input: $input)
  }
`;

const CREATE_CLIENT_CONTRACT_NEW = gql`
  mutation createClientBillingContract($input: CreateClientContractInput!) {
    createClientBillingContract(input: $input) {
      contract {
        contractId
      }
    }
  }
`;

const UPDATE_CLIENT_CONTRACT_NEW = gql`
  mutation updateClientBillingContract($input: UpdateClientContractInput!) {
    updateClientBillingContract(input: $input) {
      contract {
        contractId
      }
    }
  }
`;

const CREATE_CLIENT_PROVISION_RULE_FROM_TEMPLATE = gql`
  mutation createProvisionRuleFromTemplate(
    $input: CreateProvisionRuleFromTemplateInput!
  ) {
    createProvisionRuleFromTemplate(input: $input)
  }
`;

const CREATE_CLIENT_CONTRACT_FROM_BILLING_TEMPLATE = gql`
  mutation createClientContractFromBillingTemplate(
    $input: CreateClientContractFromBillingTemplateInput!
  ) {
    createClientContractFromBillingTemplate(input: $input)
  }
`;

const UPDATE_CLIENT_CONTRACT_ORDER = gql`
  mutation updateClientContractsOrder($input: [ClientContractOrderInput!]!) {
    updateClientContractsOrder(input: $input)
  }
`;

export {
  CREATE_CLIENT_CONTRACT_NEW,
  UPDATE_CLIENT_CONTRACT_NEW,
  DELETE_CLIENT_CONTRACT_NEW,
  EXPIRE_CLIENT_CONTRACT_NEW,
  HARD_RESET_CLIENT_CONTRACTS,
  UPDATE_CLIENT_CONTRACT_ORDER,
  CREATE_CLIENT_CONTRACT_FROM_BILLING_TEMPLATE,
  CREATE_CLIENT_PROVISION_RULE_FROM_TEMPLATE
};
